import React, { Component, Fragment, useEffect, useState, useRef } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { getWorkshopById, bookWorkshop } from '../../../Services/WorkshopServices';
import { utils } from '../../../helpers/utils';
import { CalendarEvent } from '../../../Types/CalendarEvent';


export type BookWorkshopFormValues = {
    [key: string]: any;
}

export type BookWorkshopFormRef = {
    [key: string]: React.RefObject<HTMLElement | null>
}

export type BookWorkshopFormErrors = {
    [key: string]: string;
}

export type BookWorkshopFormTouched = {
    [key: string]: boolean;
}

export type ValidtionFunctions = {
    [key: string]: Function;
}

export type BookWorkshopFormMasterData = {
    workshopId: number;
    workshopTypeId: string | null;
    workshopDate: string | null;
    startDate: string | null;
    endDate: string | null;
    workshopMode: string | null;
    location: string | null;
    meetingInformation: string | null;
    meetingInformationContext: string | null;
    roomNumber: string | null;
}

export function useBookWorkshopForm() {
    const history = useHistory();

    let { WId } = useParams<{ WId: string }>();

    useEffect(() => {
        fetchData(WId);
    }, []);

    async function fetchData(WId?: string) {
        try {
            //get ESP data by presentationId
            if (WId) {
                const id: number = parseInt(WId);
                getWorkshopById(id, false).then((response) => {
                    if (response && response.status === 200 && response.data) {
                        let newData:BookWorkshopFormMasterData = response.data as BookWorkshopFormMasterData;
                        setMasterData(newData);
                    } else {
                        throw new Error('Unable to fetch Employer Spotlight Presentation data!');
                    }

                })

            }

        } catch (error) {
            Swal.fire(
                {
                    icon: 'error',
                    title: 'Error While Processing',
                    text: `Unable to get data for the form.`,
                    showConfirmButton: true,
                    confirmButtonText: "OK",
                    confirmButtonColor: '#1678c2'
                }
            ).then(() => {
            });
        }

    }

    const defaultValues: BookWorkshopFormValues = {

        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        confirmEmail: '',
        additionalInformation:'',

    };
    const validations = {

        firstName: async function (values: BookWorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.firstName) {
                        error = 'Please enter first name';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        lastName: async function (values: BookWorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.lastName) {
                        error = 'Please enter last name';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        phoneNumber: async function (values: BookWorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        email: async function (values: BookWorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!(values.email && isValidEmail(values.email) === true)) {
                        error = 'Please provide a valid email'
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        confirmEmail: async function (values: BookWorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!(values.confirmEmail && isValidEmail(values.confirmEmail) === true)) {
                        error = 'Please provide a valid email'
                    }else if(values.confirmEmail !== values.email){
                        error = 'Email entries does not match'
                    }

                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        additionalInformation: async function (values: BookWorkshopFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.

                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },

    }

    let isSubmit = false;
    const debounceTime = 250;
    const ref = useRef(initRefs(defaultValues));
    const [values, setValues] = useState<BookWorkshopFormValues>(defaultValues);
    const [errors, setErrors] = useState<BookWorkshopFormErrors>({});
    const [touched, setTouched] = useState<BookWorkshopFormTouched>({});
    //const debouncedValidateForm = _.debounce(validateForm, debounceTime);
    const debouncedValidateForm = validateForm;
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [masterData, setMasterData] = useState<BookWorkshopFormMasterData | null>(null);
    const [submitSuccess, setSubmitSuccess] = useState<boolean>(false);

    let validationCount = 0;
    let validationTotal = 1;

    function initRefs(viewModel: BookWorkshopFormValues) {
        if (viewModel == null) {
            return {};
        } else {
            let result: BookWorkshopFormRef = {};
            Object.keys(viewModel).forEach((key) => {
                result[key] = React.createRef<HTMLElement | null>();
            });
            return result;
        }
    }

    function registerRef(ref: HTMLElement | null) {
        console.log(ref);
        console.log(typeof ref);
    }

    function touchAll() {
        let keys = Object.keys(defaultValues);
        keys.forEach((key) => {
            touched[key] = true;
        });
        setTouched(touched);
    }

    function counterHit(currentError: BookWorkshopFormErrors) {
        validationCount += 1;
        // we did not handle timeout problem, but it will in future
        if (validationCount === validationTotal) {
            validationCount = 0;
            if (_.isEmpty(currentError)) {
                setIsValid(true);
                if (isSubmit === true) {
                    isSubmit = false;
                    setIsLoading(true);
                    saveData({ ...values });
                } else {
                    setIsLoading(false);
                }
            } else {
                if (isSubmit === true) {
                    isSubmit = false;
                }
                if (isValid !== false) {
                    setIsValid(false);
                }
                setIsLoading(false);
            }


        }
    }

    function saveData(viewModel: BookWorkshopFormValues) {
        setIsSubmitting(true);
        setIsLoading(true);
        setErrorMessage(null);
        let newData = _.cloneDeep(viewModel);
        newData.workshopId = parseInt(WId);
        delete newData.confirmEmail;
        bookWorkshop(newData,false).then((res) => {
            setIsLoading(false);
            setIsSubmitting(false);
            if (res && res.status === 200) {
                setSubmitSuccess(true);
                //console.log(res);
            } else if (res && res.status === 401) {
                setIsValid(false);
                
            }
            else {
                Swal.fire(
                    {
                        icon: 'error',
                        title: 'Error While Processing',
                        text: `${res && res.data ? res.data : "No detail reason available."}`,
                        showConfirmButton: true,
                        confirmButtonText: "OK",
                        confirmButtonColor: '#1678c2'
                    }
                ).then(() => {
                });
            }
        }, (error) => {
            setIsLoading(false);
            setIsSubmitting(false);
            if (error.response && error.response.data && error.response.status === 500) {
                let footer = '';
                Swal.fire(
                    {
                        icon: 'error',
                        title: 'Error While Processing',
                        text: `${error.response.data ? error.response.data : "No detail reason available"}`,
                        showConfirmButton: true,
                        footer: footer,
                        confirmButtonText: "OK",
                    }
                ).then(() => {
                });
            }
        });
    }

    function resetForm() {
        Object.keys(defaultValues).forEach((key, index) => {
            let temp = ref.current[key].current;
            if (temp != null) {
                // not implemented yet
            }
        });
        setValues(defaultValues);
        setIsLoading(false);
        setTouched({});
        setErrors({});
    }

    async function handleSubmit() {
        touchAll();
        setIsLoading(true);
        validateForm(values, validations, null);
        isSubmit = true;
    }

    function validateForm(values: BookWorkshopFormValues, validations: ValidtionFunctions, fieldName: string | null = null) {
        let newErrors: BookWorkshopFormErrors = {};
        setIsLoading(true);
        if (fieldName != null) {
            // only validate the changing field.Keep current errors info
            newErrors = errors;
            validationTotal = 1;
            validationCount = 0;
            validations[fieldName](values).then(() => {
                delete newErrors[fieldName];
                setErrors(newErrors);
                counterHit(newErrors);
            }, (error: string) => {
                newErrors[fieldName] = error;
                setErrors(newErrors);
                counterHit(newErrors);
            });
        } else {
            // if this validate is not trigered by input control change, validate all.
            let keys = Object.keys(defaultValues);
            validationTotal = keys.length > 0 ? keys.length : 0;
            validationCount = 0;
            keys.forEach((key) => {
                validations[key](values).then(() => {
                    delete newErrors[key];
                    setErrors(newErrors);
                    counterHit(newErrors);
                }, (error: string) => {
                    newErrors[key] = error;
                    setErrors(newErrors);
                    counterHit(newErrors);
                });
            });

        }

    }


    function handleBlur(fieldName: string) {
        if (errorMessage != null) {
            setErrorMessage(null);
        }
        setTimeout(() => {
            setTouched((prevValue) => {
                return {
                    ...prevValue,
                    [fieldName]: true,
                }
            });
            validateForm(values, validations, null);
        }, 250);
    }

    function handleChange(newValue: any, fieldName: string, fieldOnly = true) {
        if (errorMessage != null) {
            setErrorMessage(null);
        }
        values[fieldName] = newValue;
        setValues(values);
        if (!(touched[fieldName] != null)) {
            setTouched({ ...touched, [fieldName]: true });
        }
        debouncedValidateForm(values, validations, fieldOnly ? fieldName : null);
    }

    function isValidEmail(testTarget: string) {
        let myReg = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi;
        return myReg.test(testTarget);
    }


    return [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, registerRef, handleChange, handleBlur, handleSubmit] as const;

}
